import { UMBRACO_GUID_IDA_DK_MENU as e, UMBRACO_GUID_MIT_IDA_MENU as C, UMBRACO_GUID_MIT_IDA_MENUITEM_ACTIVE as O, UMBRACO_GUID_MIT_IDA_MENUITEM_ACTIVE_EN as N, UMBRACO_GUID_MIT_IDA_MENUITEM_CONTACT as i, UMBRACO_GUID_MIT_IDA_MENUITEM_CONTACT_EN as c, UMBRACO_GUID_MIT_IDA_MENUITEM_TOOLS as o, UMBRACO_GUID_MIT_IDA_MENUITEM_TOOLS_EN as R } from "./constants.js";
const T = (_) => {
  const t = /width:\s*([\d.]+)px;/, U = /height:\s*([\d.]+)px/, I = _.match(t), M = _.match(U), h = I ? I[1] : "100%", A = M ? M[1] : "100%";
  return { width: `${h}px`, height: `${A}px` };
};
export {
  e as UMBRACO_GUID_IDA_DK_MENU,
  C as UMBRACO_GUID_MIT_IDA_MENU,
  O as UMBRACO_GUID_MIT_IDA_MENUITEM_ACTIVE,
  N as UMBRACO_GUID_MIT_IDA_MENUITEM_ACTIVE_EN,
  i as UMBRACO_GUID_MIT_IDA_MENUITEM_CONTACT,
  c as UMBRACO_GUID_MIT_IDA_MENUITEM_CONTACT_EN,
  o as UMBRACO_GUID_MIT_IDA_MENUITEM_TOOLS,
  R as UMBRACO_GUID_MIT_IDA_MENUITEM_TOOLS_EN,
  T as extractWidthAndHeight
};
